import React from 'react';
import classnames from 'classnames';
import { Props as IconWrapProps, IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';

import s from './StatisticsBarItem.scss';

export interface Props {
  icon: React.ComponentType<IconWrapProps>;
  label: string;
  className?: string;
}

const StatisticsBarItem: React.FC<Props> = ({ icon: IconComponent, label, className }) => (
  <Flex inline className={classnames(s['root'], className)} alignItems="center">
    <IconComponent className={s['icon']} size={IconSize.SMALLER} disableDefaultColors />
    <span>{label}</span>
  </Flex>
);
StatisticsBarItem.displayName = 'StatisticsBarItem';

export default StatisticsBarItem;
